<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col v-if="agent" cols="2" align="start" class="align-content-center">
                <div>
                    <v-img
                        :src="this.$store.getters.getClientImage"
                        class="rounded-circle mx-auto"
                        max-width="40"
                    />
                </div>
            </v-col>
            <v-col cols="10" align="start" class="ml-auto">
                <div
                    class="white--text rounded-xl px-3 py-3 bubble-text"
                    :class="[agent ? 'grey--text text--darken-4 grey lighten-3 float-left' : 'float-right']"
                    :style="`background-color: ${mainColor}`"
                >
                    {{ reply.message.text }}
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        props: {
            agent: {
                type: Boolean,
                default: false
            },
            reply: {
                type: Object,
            },
            mainColor: {
                type: String,
                default: null
            }
        },
        data: () => ({
            data:
            {
                "message":
                {
                    "text":"Hello, world!"
                }
            }
        }),
        methods: {
        }
    }
</script>